import Select, { Props, StylesConfig } from 'react-select';

export function Selector(props: Props = {}) {
    
    const customStyles: StylesConfig = {
        control: (provided) => ({...provided, cursor: 'pointer' }),
        // react-select's default menu z-index (1) ties with other z-index:1
        // content later in the DOM (e.g. SegmentedControl segments), which
        // then paints over the open options list.
        menu: (provided) => ({ ...provided, zIndex: 5 }),
    };

    return <Select styles={customStyles} {...props} />;
}